import React from 'react';

function CampusMap() {
    return (
        <div className="container">
            <p className="title-3">Plan du campus</p>
            <p className="paragraph">
                Encore un peu de temps ! Le plan du campus sera bientôt
                disponible pour vous guider. En attendant, vous pouvez consulter
                le plan ici :{' '}
                <a href="https://www.unamur.be/sites/default/files/2023-12/plancampusaveclegende.pdf">
                    Plan du campus
                </a>.
            </p>
        </div>
    );
}

export default CampusMap;
